import { IconPrinter } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Focusable, Tooltip } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

import { TranslationKey } from '@/i18n';

export interface PrintReportButtonProps {
  onClick: (e: React.MouseEvent) => void;
  disabled?: boolean;
  className?: string;
  tooltip?: TranslationKey;
  'data-testid'?: string;
}

const PrintReportButton: React.FC<PrintReportButtonProps> = ({
  onClick,
  disabled = false,
  className,
  tooltip = 'Button.printReport',
  'data-testid': dataTestId = 'print-report-button',
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip.Root delay={500}>
      <Focusable>
        <button
          className={cn(
            'pointer-events-auto! border-none bg-transparent p-0',
            disabled
              ? 'text-grayscale-gray3! cursor-not-allowed'
              : 'text-secondary-base! cursor-pointer',
            className,
          )}
          data-testid={dataTestId}
          disabled={disabled}
          onClick={e => {
            if (!disabled) {
              onClick(e);
            }
          }}
        >
          <IconPrinter />
        </button>
      </Focusable>
      <Tooltip.Content>{t(tooltip)}</Tooltip.Content>
    </Tooltip.Root>
  );
};

export default PrintReportButton;
